import * as webfontloader from 'webfontloader';
import { watchScroll } from './lib/scroll';

/**
 * Benchmarking
 */
const timeStart = window.performance.now();

/**
 * Configure fonts for this project
 */
const webfonts = {
	google: {
		families: [
			'Quicksand:100,200,300,400,500,600,700',
		],
	},
};

document.addEventListener('DOMContentLoaded', () => {
	/**
	 * Load Webfonts
	 */
	webfontloader.load(webfonts);

	// Do stuff...
	watchScroll();

	/**
	 * Benchmarking reporting
	 */
	const timeEnd = window.performance.now();
	console.info(`Execution time: ${timeEnd - timeStart}ms after DOMContentLoaded.`);
});
